import type { GDSInputStatus } from '@leagueplatform/genesis-core';

export const getInputStatusWithHiddenUnicodeWarning = (
  inputStatus: GDSInputStatus | undefined,
  hasHiddenCharacters: boolean,
): GDSInputStatus | undefined => {
  if (inputStatus === 'error') {
    return 'error';
  }

  if (hasHiddenCharacters) {
    return 'warning';
  }

  return inputStatus;
};
